import { render, staticRenderFns } from "./CaseNameSetup.vue?vue&type=template&id=5c920154&scoped=true&"
import script from "./CaseNameSetup.vue?vue&type=script&lang=ts&"
export * from "./CaseNameSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c920154",
  null
  
)

export default component.exports